import React from "react";
import { Button } from "semantic-ui-react";

import $ from "jquery";
import moment from "moment";
import { toast } from "react-toastify";

function ButtonExport(props) {

    function handleClickExport(e) {
        const checkboxes = $("#exportConfig .ui.checkbox");
        let exportJson = {}
        let sumDisabled = 0;
        if ($(checkboxes.get(0)).hasClass("checked")) {
            const defaultImage = (getLocal("default-image")) ? getLocal("default-image") : null;
            const defaultImageName = (getLocal("default-image-name")) ? getLocal("default-image-name") : null;
            const checkboxOption = (getLocal("checkbox-option")) ? getLocal("checkbox-option") : null;
            const images = (getLocal("images")) ? getLocalJson("images") : null;
            exportJson["background"] = { "default-image": defaultImage, "default-image-name": defaultImageName, "checkbox-option": checkboxOption, "images": images };
        } else {
            sumDisabled++;
        }
        if ($(checkboxes.get(1)).hasClass("checked")) {
            const dataFavorite = (getLocal("dataFavorite")) ? getLocalJson("dataFavorite") : null;
            exportJson['favorites'] = { "dataFavorite": dataFavorite }
        } else {
            sumDisabled++;
        }
        if ($(checkboxes.get(2)).hasClass("checked")) {
            const settings = (getLocal("settings")) ? getLocalJson("settings") : null;
            exportJson['settings'] = { "settings": settings }
        } else {
            sumDisabled++;
        }

        if (sumDisabled === 3) {
            toast.error((props.lang === "es") ? 'Ninguna opcion seleccionada' : 'No option selected', {
                position: "top-center",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } else {
            var file = $("<a id='temp-file-download'></a>").attr({ href: 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(exportJson)), download: "custom_new_tab" + moment().format("_YYYY_MM_DD_hh_mm_ss") + ".json" }).css({ display: "none" });
            file[0].click();
        }
    }

    function getLocal(name) {
        return localStorage.getItem(name);
    }

    function getLocalJson(name) {
        return JSON.parse(getLocal(name));
    }

    return (
        <Button primary fluid content={props.content} size="large" onClick={handleClickExport} />
    );
}

export default ButtonExport;